import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#0AA1F4"
        d="M8 9.333v1.334a4 4 0 00-4 4H2.667A5.333 5.333 0 018 9.333zm0-.666c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-1.334A2.666 2.666 0 108 2a2.666 2.666 0 100 5.333zm1.73 5.208a2.34 2.34 0 010-1.082l-.662-.382.667-1.154.662.382a2.33 2.33 0 01.936-.542V9h1.333v.763c.355.106.675.294.937.542l.662-.382.666 1.154-.661.382c.084.356.084.726 0 1.082l.661.382-.666 1.154-.662-.382a2.33 2.33 0 01-.937.542V15h-1.333v-.763a2.33 2.33 0 01-.937-.542l-.66.382-.668-1.154.662-.382zm2.27.46a1 1 0 100-2 1 1 0 000 2z"
      ></path>
    </svg>
  )
}

export default Icon
